<div class="box">
	<i class="fa fa-question-mark"></i>
	<div class="box__info">
		<p class="box__info__title">{{ title }}</p>
		<p class="box__info__text">
			<ng-content></ng-content>
		</p>
	</div>
</div>
